import { render, staticRenderFns } from "./UpdateCategoryForm.vue?vue&type=template&id=08454bb5"
import script from "./UpdateCategoryForm.vue?vue&type=script&lang=js"
export * from "./UpdateCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports